import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
export default function CreateWaveInlineGroupExpandedPanel(t0) {
  const $ = _c(8);
  const {
    children,
    onCancel,
    cancelClassName: t1
  } = t0;
  const cancelClassName = t1 === undefined ? "" : t1;
  let t2;
  if ($[0] !== children) {
    t2 = <div className="tw-min-w-0 tw-flex-1">{children}</div>;
    $[0] = children;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `tw-flex-shrink-0 tw-rounded-lg tw-border tw-border-solid tw-border-transparent tw-bg-transparent tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-text-iron-500 tw-transition tw-duration-200 desktop-hover:hover:tw-text-iron-100 ${cancelClassName}`;
  let t4;
  if ($[2] !== onCancel || $[3] !== t3) {
    t4 = <button type="button" onClick={onCancel} className={t3}>Cancel</button>;
    $[2] = onCancel;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2 || $[6] !== t4) {
    t5 = <div className="tw-relative tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-white/5 tw-pt-5"><div className="tw-flex tw-items-start tw-gap-3">{t2}{t4}</div></div>;
    $[5] = t2;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}